import Spinner from '@/images/spinner.svg';
import { ReactNode } from 'react';

const Loader = ({
  isLoading,
  children,
  className,
}: {
  isLoading: boolean;
  children: ReactNode;
  className?: string;
}) => {
  return isLoading ? (
    <div className={`flex h-full items-center justify-center w-full ${className}`} data-testid="loader">
      <img src={Spinner} alt="Loading..." className="flex h-[25px] w-[25px] animate-spin justify-center " />
    </div>
  ) : (
    children
  );
};

export default Loader;
